import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.addMiscellaneous = (miscellaneous) => {
  miscellaneous = Object.assign({}, miscellaneous);

  const promises = [];
  return http
    .post("/miscellaneous/create", {
      cityId: miscellaneous.cityId,
      expense: miscellaneous.expense,
      expenseDate: miscellaneous.expenseDate,
      expenseType: miscellaneous.expenseType,
      amount: miscellaneous.amount,
      receipt: miscellaneous.receipt.toString(),
      segregationPlant: miscellaneous.segregationPlant,
    })
    .then((result) => {
      miscellaneous = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("miscellaneous.create-error:\n", error);
      throw error;
    });
};

internals.updateMisCallaneous = (_id, miscellaneous) => {
  return http
    .put(`/miscellaneous/update`, {
      cityId: miscellaneous.cityId,
      expense: miscellaneous.expense,
      expenseDate: miscellaneous.expenseDate,
      expenseType: miscellaneous.expenseType,
      amount: miscellaneous.amount,
      receipt: miscellaneous.receipt.toString(),
      segregationPlant: miscellaneous.segregationPlant,
      _id: miscellaneous._id,
    })
    .then((result) => {
      miscellaneous = result.data;
      return miscellaneous;
    })
    .catch((error) => {
      console.error("miscellaneous.updateVehicle-error:\n", error);
      throw error;
    });
};

internals.deleteMisCellaneous = (_id) => {
  return http
    .delete(`/miscellaneous/delete?_id=` + _id)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("miscellaneous.delete-error:\n", error);
      throw error;
    });
};

internals.getById = (Id) => {
  return http
    .get(`miscellaneous/getById?_id=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("miscellaneous-error:\n", error);
      throw error;
    });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/misCellaneous.service.js